import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button from 'components/common/button';
import TeamAssistIcon from 'components/lib/icons/team_assist_icon';
import ToggleTeamAssistPanel from 'actions/team_assist/toggle_team_assist_panel';
import { useExecuteAction } from 'components/hooks/connect_hooks';

export default function TeamAssistPanelToggleButton({ isActive }) {
  const executeAction = useExecuteAction();
  const onClick = useCallback(() => executeAction(ToggleTeamAssistPanel), [executeAction]);

  // Unlike the answer and task toggles, this one keeps its icon on hover rather
  // than swapping in an ✕ — only the background reacts.
  return (
    <div>
      <StyledButton data-aid="teamAssistPanelToggleButton" isActive={isActive} onClick={onClick}>
        <StyledIcon height="11" width="11" />
      </StyledButton>
    </div>
  );
}

TeamAssistPanelToggleButton.propTypes = {
  isActive: PropTypes.bool,
};

const StyledButton = styled(Button)`
  align-items: center;
  background-color: ${p => (p.isActive ? p.theme.colors.purple400 : p.theme.colors.white)};
  border: 1px solid ${p => p.theme.colors.purple400};
  border-right: none;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 0;
  border-top-left-radius: 50%;
  border-top-right-radius: 0;
  box-shadow: ${p => p.theme.boxShadow.small};
  /* Literal white, not theme.colors.white: that token is a surface color and
     resolves to a near-black in dark mode, which rendered the icon dark grey on
     the purple tab. Same reason the answer panel toggle hardcodes white. */
  color: ${p => (p.isActive ? 'white' : p.theme.colors.purple400)};
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: 4px;
  width: 24px;
  /* Only the background reacts to hover — the icon keeps its resting color. */
  &:hover {
    background-color: ${p => p.theme.colors.purple500};
  }
`;

const StyledIcon = styled(TeamAssistIcon)`
  color: inherit;
`;
